import { useState } from 'react';
import { Popup } from './Popup';
import { Button, Toggle, Title, TextButton } from './ui';
import './SharePopup.css';

interface SharePopupProps {
  hasProgress: boolean;
  onShare: (includeProgress: boolean) => Promise<'shared' | 'copied' | 'failed'>;
  onClose: () => void;
}

export function SharePopup({ hasProgress, onShare, onClose }: SharePopupProps) {
  const [includeProgress, setIncludeProgress] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleCopy = async () => {
    if (busy) return;
    setBusy(true);
    await onShare(includeProgress);
    setBusy(false);
    onClose();
  };

  return (
    <Popup onDismiss={onClose} maxWidth={320} aria-label="Share puzzle">
      <div className="share-popup">
        <Title as="h2" className="share-popup__title">
          Share Puzzle
        </Title>

        {hasProgress && (
          <label className="share-popup__option">
            <span className="share-popup__option-label">Include progress</span>
            <Toggle
              checked={includeProgress}
              onChange={() => setIncludeProgress((v) => !v)}
            />
          </label>
        )}

        <Button
          variant="primary"
          size="wide-sm"
          className="share-popup__copy-btn"
          disabled={busy}
          onClick={handleCopy}
        >
          Copy Link
        </Button>

        <TextButton className="share-popup__cancel" onClick={onClose}>
          Cancel
        </TextButton>
      </div>
    </Popup>
  );
}
